import React from 'react';
import { MultiColumnEntry, MultiColumnEntryProps } from '../MultiColumnEntry/MultiColumnEntry';
import { styles } from './MultiColumnBlock.css';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';

export interface MultiColumnBlockProps {
  entries: Array<Omit<MultiColumnEntryProps, 'alignment'>>;
  alignment: 'Left' | 'Centred';
  mobileFormat: 'Stack' | 'Carousel';
  theme?: ContentThemePalette;
}

export const MultiColumnBlock: React.FC<MultiColumnBlockProps> = ({ entries, alignment, mobileFormat, theme }) => {
  const isCentred = alignment === 'Centred';
  const isDesktop = useBreakpoint('md', 'up');

  const items = entries?.map((entry, index) => <MultiColumnEntry key={index} {...entry} alignment={alignment} />);

  return (
    <div className={styles.container({ isCentred })} style={{ backgroundColor: theme?.background }}>
      {!isDesktop && mobileFormat === 'Carousel' ? (
        <Carousel slidesPerView={1.2} showPagination={false} fullBleed fullHeightItems showArrows={false}>
          {items}
        </Carousel>
      ) : (
        items
      )}
    </div>
  );
};
